import sendGetAction from './sendGetAction'

const get = ({ path, parameters }) => sendGetAction('GET', { path, parameters })

export default get
